export const types = {
  SHOW_IMAGE_VIEWER: 'SHOW_IMAGE_VIEWER',
  HIDE_IMAGE_VIEWER: 'HIDE_IMAGE_VIEWER',
};

export const actions = {
  showImageViewer: (image) => ({
    type: types.SHOW_IMAGE_VIEWER,
    payload: {
      image,
    },
  }),
  hideImageViewer: () => ({
    type: types.HIDE_IMAGE_VIEWER,
  }),
};

const initialState = {
  showImageViewer: false,
  image: '',
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SHOW_IMAGE_VIEWER:
      return {
        ...state,
        showImageViewer: true,
        image: action.payload.image,
      };
    case types.HIDE_IMAGE_VIEWER:
      return {
        ...state,
        showImageViewer: false,
      };
    default:
      return state;
  }
};

export default reducer;

export const getImageViewerStatus = (state) =>
  state.imageViewer.showImageViewer;
export const getImageUrl = (state) => state.imageViewer.image;



// WEBPACK FOOTER //
// ./src/services/redux/imageViewer.js